import { render, staticRenderFns } from "./GeneralModal.vue?vue&type=template&id=64a23c0c&"
import script from "./GeneralModal.vue?vue&type=script&lang=js&"
export * from "./GeneralModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports